module.exports = __webpack_public_path__ + "img/UTESCA.81a601a6.png";